export interface FooterProps {
  isSubmitting: boolean
  onDelete?: () => void
  onCancel: () => void
  disabled: boolean
  onSubmit: () => void
}
